import styled from 'styled-components';
import C from '@assets/themes/colors';
interface IProps {
  selected?: boolean;
  leftValue?: string;
  topValue?: string;
  display?: string;
}

export const FontFamilyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const PreviewImage = styled.img`
  height: 113px;
  width: 100%;
  margin: 21px 0px 8px 0px;
  border-radius: 5px;
  object-fit: contain;
  background-color: rgba(196, 196, 196, 0.5);
`

export const ImageOptions = styled.div`
position: absolute;
bottom: 0px;
margin: 0px;
width: 100%;
display: flex;
padding: 5px 0px 5px 0px;
border-radius: 0px 0px 5px 5px;
background-color: rgba(32, 64, 120, 0.7);
`

export const TagsContainer = styled.div`
padding: 5px;
font-size: 12px;
font-weight: 500;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;  
color: white;
display:inline-block;  
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
text-align: left;
`;

export const OptionContainer = styled.div`
padding: 2px 12px 2px 2px;
color: white;
display:flex;
margin-left: auto;

`;

export const Tooltip = styled.div`
  position: fixed;
  padding: 9px 12px;
  width: auto;
  z-index: 1000;
  background-color: ${C.DARKEST_GRAY};
  font-size: 11px;
  font-weight: 500;
  color: ${C.DARKER_WHITE};
  left: ${(props: IProps) => (props.leftValue ? props.leftValue : '')};
  top: ${(props: IProps) => (props.topValue ? props.topValue : '')};
  display: ${(props: IProps) => (props.display ? props.display : '')};
`;